module.exports = eval("try{require('os')}catch(e){}");